import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { MultiplierIcon } from "../shared/Brand";

export const LRSSection = () => (
  <section id="lrs" className="py-12 sm:py-16 bg-[#1C1C1C] border-y border-white/5" data-testid="lrs-section">
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-12 flex flex-col sm:flex-row gap-6 sm:gap-8 items-start">
      <MultiplierIcon size={48} className="flex-shrink-0" />
      <div>
        <h2 className="text-xl sm:text-2xl font-semibold text-white mb-3">Leitner Revenue Systems</h2>
        <p className="text-sm sm:text-base text-zinc-300 leading-relaxed mb-5">
          Dan's independent GTM consultancy helping B2B companies improve Sales Development strategy, pipeline generation, GTM operations, AI-assisted prospecting, coaching, CRM workflows, and revenue systems.
        </p>
        <div className="flex flex-wrap gap-5 text-sm">
          <Link to="/services" className="text-[#D4AF37] hover:text-[#E8C547] inline-flex items-center gap-1 transition-colors" data-testid="lrs-services-link">
            Services <ArrowRight className="w-4 h-4" />
          </Link>
          <Link to="/approach" className="text-[#D4AF37] hover:text-[#E8C547] inline-flex items-center gap-1 transition-colors" data-testid="lrs-approach-link">
            The Leitner Revenue System <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </div>
  </section>
);

export default LRSSection;
